import React from "react";

// reactstrap components
import {
  Form,
  Container,
  Col,
  Row,
  Spinner
} from "reactstrap";
import { CardLogin } from 'components/Login/Login';

class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="login-page">
          <Row className="row-login">
            <Col >
              <img style={{width: "100%"}} src={require("assets/img/corretora-img.png")}></img>
            </Col>
            <hr className="line-login"></hr>
            <Col style={{maxWidth: 440}}>
            {
              this.props.isLoading ? <Spinner color="primary" className="auth-loading" /> : <Form action="" className="form" method="">
                <CardLogin history={this.props.history} errorMessage={this.props.errorMessage} doLogin={this.props.doLogin} onChange={this.props.onChange} />
              </Form>
            }
            </Col>
          </Row>
      </div>
    );
  }
}

export default Login;
